import cntl from "cntl";
import PropTypes from "prop-types";
import TabButton from "./TabButton";
import { useState, useMemo } from "react";
import { SIZE } from "../constants/index";

const propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  tabIndex: PropTypes.string,
  isDisabled: PropTypes.bool,
  classname: PropTypes.string,
  ariaSelected: PropTypes.string,
  ariaControls: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function TabButtonUnderline({
  id,
  size,
  label,
  onClick,
  children,
  tabIndex,
  className,
  isDisabled,
  ariaSelected,
  ariaControls,
}) {
  const [padding, setPadding] = useState("");

  const tabButtonUnderlineCn = () => cntl`
    border-b-2
    rounded-none
    bg-transparent
    border-b-transparent
    ${padding}
    ${
      ariaSelected === "true"
        ? cntl`text-primary-700 border-b-primary-700 rounded-b-none`
        : !!!isDisabled && cntl`text-grey-500 hover:text-primary-700 hover:border-b-primary-700 hover:rounded-b-none`
    }
    ${className ? className : undefined}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setPadding("px-1 pb-3.5");
        break;
      case SIZE.md:
        setPadding("px-1 pb-3.5");
        break;
      default:
        setPadding("px-1 pb-3.5");
        break;
    }
  }, [size]);

  return (
    <TabButton
      id={id}
      size={size}
      label={label}
      onClick={onClick}
      tabIndex={tabIndex}
      isDisabled={isDisabled}
      ariaSelected={ariaSelected}
      ariaControls={ariaControls}
      className={tabButtonUnderlineCn()}
    >
      {children}
    </TabButton>
  );
}

TabButtonUnderline.propTypes = propTypes;
export default TabButtonUnderline;
